import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { getPlaceholderCoreProps, useComputeCalendarConfiguration } from "./useComputeCalendarConfiguration.js";
const context = createContext(getPlaceholderCoreProps());
function CalendarRoot(props) {
  const { configuration, children } = props;
  const contextValue = useComputeCalendarConfiguration(configuration);
  return /* @__PURE__ */ jsx(context.Provider, { value: contextValue, children });
}
function useCalendarConfiguration() {
  return useContext(context);
}
export {
  CalendarRoot,
  useCalendarConfiguration
};
//# sourceMappingURL=CalendarRoot.js.map
